import { render, staticRenderFns } from "./fancy-button.vue?vue&type=template&id=12af012a&scoped=true"
import script from "./fancy-button.vue?vue&type=script&lang=js"
export * from "./fancy-button.vue?vue&type=script&lang=js"
import style0 from "./fancy-button.vue?vue&type=style&index=0&id=12af012a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af012a",
  null
  
)

export default component.exports